import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const GoldStarIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 11 11">
		<path
			opacity={0.4}
			fill="currentColor"
			d="M3.06236 6.96328C3.10881 6.75635 3.02435 6.46072 2.87654 6.31291L1.8503 5.28667C1.52933 4.9657 1.40264 4.62362 1.49555 4.328C1.59268 4.03237 1.89253 3.82966 2.34019 3.75364L3.65783 3.53403C3.84788 3.50025 4.08015 3.33132 4.16884 3.15817L4.89523 1.70116C5.1064 1.28306 5.39357 1.05078 5.70609 1.05078C6.01861 1.05078 6.30579 1.28306 6.51695 1.70116L7.24334 3.15817C7.29824 3.26797 7.41227 3.37355 7.53475 3.44534L2.98634 7.99375C2.92722 8.05287 2.82586 7.99797 2.84275 7.91351L3.06236 6.96328Z"
		/>

		<path
			fill="currentColor"
			d="M8.5352 6.31507C8.38316 6.46711 8.2987 6.75851 8.34938 6.96545L8.64078 8.23663C8.76325 8.76454 8.68723 9.16152 8.42539 9.35156C8.31981 9.42758 8.19312 9.46559 8.04531 9.46559C7.82992 9.46559 7.57653 9.38535 7.2978 9.22064L6.06039 8.4858C5.86613 8.37178 5.54516 8.37178 5.35089 8.4858L4.11349 9.22064C3.64471 9.49515 3.24351 9.54161 2.98589 9.35156C2.88876 9.27977 2.81696 9.18263 2.77051 9.05594L7.90594 3.92051C8.10021 3.72624 8.37472 3.63755 8.64078 3.68401L9.06732 3.7558C9.51498 3.83182 9.81483 4.03453 9.91197 4.33016C10.0049 4.62578 9.87818 4.96786 9.55722 5.28883L8.5352 6.31507Z"
		/>
	</SvgIcon>
)

export default GoldStarIconAtom
